import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BreadCrumb.js");
;
import(/* webpackMode: "eager", webpackExports: ["JsonLdScript"] */ "/app/src/components/JsonLdScript.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pageBuilder/PageBuilderClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["useHotelDetailAddToCartAnalytics"] */ "/app/src/components/pages/hotel/detail/hooks/useHotelDetailAddToCartAnalytics.js");
;
import(/* webpackMode: "eager", webpackExports: ["useHotelDetailViewItemAnalytics"] */ "/app/src/components/pages/hotel/detail/hooks/useHotelDetailViewItemAnalytics.js");
;
import(/* webpackMode: "eager", webpackExports: ["useHotelShareAnalytics"] */ "/app/src/components/pages/hotel/detail/hooks/useHotelShareAnalytics.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/hotel/detail/HotelDetailWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/hotel/HeaderSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pages/hotel/landings/LandingPageContent.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VirtualPvEvent.js");
;
import(/* webpackMode: "eager", webpackExports: ["hotelHomeComponentRegistry","hotelHomeItemPropMapping"] */ "/app/src/configs/hotel/landing-pages/abroad-pages/registry.js");
;
import(/* webpackMode: "eager", webpackExports: ["hotelHomeComponentRegistry","hotelHomeItemPropMapping"] */ "/app/src/configs/hotel/landing-pages/category-pages/registry.js");
;
import(/* webpackMode: "eager", webpackExports: ["hotelHomeComponentRegistry","hotelHomeItemPropMapping"] */ "/app/src/configs/hotel/landing-pages/home/registry.js");
;
import(/* webpackMode: "eager", webpackExports: ["hotelHomeComponentRegistry","hotelHomeItemPropMapping"] */ "/app/src/configs/hotel/landing-pages/location-pages/registry.js");
;
import(/* webpackMode: "eager" */ "/app/src/configs/hotel/landing-pages/styles/landing-pages.module.css");
